module.exports = __webpack_public_path__ + "img/sc.82ccb789.svg";